/* eslint class-methods-use-this: 0 */
import { MeRepository } from 'common/repositories/index';

const _serviceDependencies = ['$scope', 'Util'];

let _Util;
/**
 * @ngdoc service
 * @name controllers.GetReport
 *
 * @description
 * Request GDPR report modal confimartion
 */
class GetReport {

    /**
     * @param  {any} $scope
     * @param  {any} Util
     */
    constructor($scope, Util) {

        _Util = Util;
        $scope.email = MeRepository.getMyUser().attributes.email;
        $scope.closeModal = this.closeModal;

    }

    closeModal() {

        _Util.closeModal();

    }

}

_serviceDependencies.push(GetReport);

angular.module('controllers')
    .controller('GetReport', _serviceDependencies);




// WEBPACK FOOTER //
// ./scripts/controllers/modals/my-account/get-report/get-report.js